<h2 mat-dialog-title>Start {{ assessmentName }}</h2>
<mat-dialog-content>
    <div class="dialog-content">
        @if (!submissionResult) {
            <p class="mb-3">
                Run {{ assessmentName }} for: <strong>{{ data.appName }}</strong>
            </p>

            <!-- No repository info notice -->
            @if (!hasRepositories) {
                <div class="alert alert-warning mb-3">
                    No Orion manifest or repository is associated with this application. A valid Orion manifest with at least one repository is required to run {{ assessmentName }}.
                </div>
            }

            <div class="form-group mb-3">
                <label class="form-label">
                    Repository <span class="text-danger">*</span>
                </label>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Select a repository</mat-label>
                    <mat-select [(ngModel)]="selectedRepository" (ngModelChange)="onRepositoryChange($event)" [disabled]="isSubmitting || !hasRepositories">
                        @for (repo of repositories; track repo) {
                            <mat-option [value]="repo.repositoryUrl">
                                {{ repo.displayName }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            @if (patStatus === 'loading') {
                <div class="text-center mt-3 mb-3">
                    <app-spinner [isLoading]="true" diameter="32" loadingText="Checking PAT..."></app-spinner>
                </div>
            }

            @if (patStatus === 'missing') {
                <div class="alert alert-warning mb-3 align-items-start">
                    <mat-icon class="mr-2 flex-shrink-0">lock</mat-icon>
                    <div>
                        <strong>{{ currentProviderDisplayName }} PAT required</strong>
                        <p class="mb-0 mt-1">
                            Configure your {{ currentProviderDisplayName }} Personal Access Token on your profile before running {{ assessmentName }}.
                        </p>
                        <a class="btn btn-primary mt-3" href="/profile/personal-access-tokens">Go to Personal Access Tokens</a>
                    </div>
                </div>
            }

            @if (patStatus === 'configured') {
                <div class="form-group mb-3">
                    <label for="branch" class="form-label">
                        Branch <span class="text-danger">*</span>
                    </label>
                    <input
                        id="branch"
                        type="text"
                        class="form-control"
                        [(ngModel)]="branch"
                        [disabled]="isSubmitting || !hasRepositories"
                        placeholder="e.g., main, master, develop"
                        required>
                    <small class="form-text text-muted">
                        Enter the branch name to assess
                    </small>
                </div>
            }

            <!-- Submitting spinner -->
            @if (isSubmitting) {
                <div class="text-center mt-3 mb-3">
                    <app-spinner [isLoading]="true" diameter="32" loadingText="Adding to queue..."></app-spinner>
                </div>
            }

            <!-- Error message -->
            @if (errorMessage) {
                <div class="alert alert-danger mt-3">
                    <mat-icon class="align-middle mr-2">error</mat-icon>
                    {{ errorMessage }}
                </div>
            }
        }

        <!-- Success view (after submission) -->
        @if (submissionResult) {
            <div class="text-center mt-3">
                <mat-icon class="success-icon">check_circle</mat-icon>
                <h3 class="mt-2">{{ assessmentName }} Queued Successfully</h3>
            </div>

            <div class="queue-info mt-3">
                <div class="queue-position-badge">
                    <span class="position-number">#{{ submissionResult.queuePosition }}</span>
                    <span class="position-label">in queue</span>
                </div>
                <p class="mt-2 text-muted text-center">
                    {{ assessmentName }} for <strong>{{ data.appName }}</strong> has been added to the queue.
                    The queue uses fair round-robin ordering so every user gets equal processing time.
                </p>
            </div>
        }

    </div>
</mat-dialog-content>
<mat-dialog-actions>
    @if (!submissionResult) {
        <button class="btn" (click)="onCancel()" [disabled]="isSubmitting">Cancel</button>
        <span style="flex: 1;"></span>
        @if (patStatus === 'configured') {
            <button class="btn" (click)="onStart()" [disabled]="!isValid() || isSubmitting || !hasRepositories">
                @if (!isSubmitting) {<span>Start {{ isLightweightMode ? 'Validation' : 'Assessment' }}</span>}
                @if (isSubmitting) {<span>Submitting...</span>}
            </button>
        }
    }
    @if (submissionResult) {
        <button class="btn" (click)="onClose()">Close Now</button>
    }
</mat-dialog-actions>
